import { TextLinkKind, TextLinkWidget } from '@tableau/widgets';
import { BodyCell } from '@tableau/widgets-datagrid';
import * as React from 'react';

import { GeocodingRecordDGConstants, GeocodingRecordItem } from '../recordDialog/GeocodingRecordDataGrid';

export class GeocodingRecordNameCellFormatter extends React.Component<BodyCell.Props> {
    private handleNameClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>, config: GeocodingRecordItem) => {
        e.preventDefault();
        this.props.row.data[GeocodingRecordDGConstants.HandleEdit](config);
    };

    public render(): JSX.Element {
        const rowData = this.props.row.data;
        const configObj: GeocodingRecordItem = rowData[GeocodingRecordDGConstants.GeocodingConfigObj];
        const name = configObj.config.name;
        return (
            <TextLinkWidget
                kind={TextLinkKind.Standalone}
                testId='geocoding-config-name'
                onClick={(e) => { this.handleNameClick(e, configObj); }}
                target='_blank'>
                    {name}
            </TextLinkWidget>
        );
    }
}
